import { render } from "./DataviewTable.vue?vue&type=template&id=a60f332e&ts=true"
import script from "./DataviewTable.vue?vue&type=script&lang=ts"
export * from "./DataviewTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__